/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Asset open position DTO
 */
export interface AssetOpenPositionDto {
  asset: Asset;
  position: number;
  volume: number;
  avgPrice?: number;
}
